


import React, { useEffect, useState } from "react";
import SpinWheelService from "../../Services/SpinWheelService";

const GiftEditor = ({ initialGifts, updateGiftsDetail }) => {
  const [gifts, setGifts] = useState([]);
  console.log(initialGifts);

  useEffect(() => {
    // Prepopulate the state with initial gifts
    if (initialGifts) {
      setGifts(initialGifts);
    }
  }, [initialGifts]);

  const handleToggle = (id) => {
    setGifts((prevGifts) =>
      prevGifts.map((gift) =>
        gift.id === id ? { ...gift, resultType: !gift.resultType } : gift
      )
    );
  };

  const handleInputChange = (id, field, value) => {
    setGifts((prevGifts) =>
      prevGifts.map((gift) => {
        if (gift.id === id) {
          let updatedValue = value;
          if (field === "odds") {
            updatedValue = Math.min(Number(value.replace(/\D/g, "")), 1000);
          }
          return { ...gift, [field]: updatedValue };
        }
        return gift;
      })
    );
  };

  const handleGiftImageUpload = async (id, file) => {
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      const bannerFolder = "spinWheelGiftImages";
      const response = await SpinWheelService.createBannerImageTemplate(
        formData,
        bannerFolder
      );
      const imageUrl = response.data.imageUrl;

      setGifts((prevGifts) =>
        prevGifts.map((gift) =>
          gift.id === id ? { ...gift, giftImageUrl: imageUrl } : gift
        )
      );
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const validateAndFormatGifts = () => {
    const isValid = gifts.every(
      (gift) => gift.giftName && gift.odds && gift.giftImageUrl && gift.id
    );

    if (isValid) {
      const formattedData = gifts.map((gift, index) => ({
        docId: gift.id,
        order: index+1,
        giftName: gift.giftName,
        odds: parseInt(gift.odds),
        giftImageUrl: gift.giftImageUrl,
        resultType: gift.resultType,
      }));

      // Pass the updated data back to the parent
      updateGiftsDetail(formattedData);
    } else {
      console.warn("Validation failed! Ensure all fields are filled.");
    }
  };

  useEffect(() => {
    validateAndFormatGifts();
  }, [gifts]);

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr className="text-customGreen text-xl">
            <th></th>
            <th>Name</th>
            <th>Image</th>
            <th>Odds</th>
            <th>Type</th>
          </tr>
        </thead>
        {gifts.map((gift, index) => (
          <tbody key={gift.id}>
            <tr>
              <td className="w-fit text-lg font-bold pt-8">Gift {index + 1}</td>
              <td className="w-52 px-4 pt-8">
                <input
                  type="text"
                  value={gift.giftName}
                  onChange={(e) =>
                    handleInputChange(gift.id, "giftName", e.target.value)
                  }
                  className="w-full h-16 border p-2 border-gray-300 bg-appGrayBackground rounded-lg focus:outline-none"
                />
              </td>
              <td className="w-52 px-4 pt-8">
                <input
                  id={`fileInput-${gift.id}`}
                  type="file"
            accept=".jpeg, .jpg, .png, .webp, .svg"
                  className="hidden"
                  onChange={(e) =>
                    handleGiftImageUpload(gift.id, e.target.files[0])
                  }
                />
                <label
                  htmlFor={`fileInput-${gift.id}`}
                  className="w-full h-16 flex items-center justify-center border border-gray-300 bg-appGrayBackground rounded-lg cursor-pointer"
                >
                  {gift.giftImageUrl ? (
                    <img
                      src={gift.giftImageUrl}
                      alt="Preview"
                      className="w-full h-full object-fit "
                    />
                  ) : (
                    "Click here to upload"
                  )}
                </label>
              </td>
              <td className="w-40 h-16 mt-8 flex items-center border border-gray-300 rounded-lg bg-appGrayBackground px-4">
                <input
                  type="text"
                  readOnly
                  value={gift.odds}
                  onChange={(e) =>
                    handleInputChange(gift.id, "odds", e.target.value)
                  }
                  className="flex-1 bg-transparent outline-none w-10"
                />
                <div className="border-l border-gray-400 h-full ml-4 pl-4 flex items-center justify-center text-gray-600">
                  <div className="text-center">
                    <div>In</div>
                    <div className="font-bold text-lg">1000</div>
                  </div>
                </div>
              </td>
              <td className="pt-8">
                <div className="flex justify-around">
                  <span>Lose</span>
                  <button
                    onClick={() => handleToggle(gift.id)}
                    className={`w-16 h-8 flex items-center rounded-full p-1 transition-colors ${
                      gift.resultType ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    <div
                      className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                        gift.resultType ? "translate-x-8" : "translate-x-0"
                      }`}
                    ></div>
                  </button>
                  <span>Win</span>
                </div>
              </td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default GiftEditor;
